/** Product mockup for Sailing Lesson Ready (all 6 volumes), shown in the hero and the pricing card. */
export const heroImage =
  'https://cdn.magicpatterns.com/uploads/kCwgnLuKv91Xpf6ixdp4QS/Photorealistic-product-mockup-photo-war.png'

export const productImage = heroImage
